import { render, staticRenderFns } from "./view-order.vue?vue&type=template&id=f11f28c8"
import script from "./view-order.vue?vue&type=script&lang=js"
export * from "./view-order.vue?vue&type=script&lang=js"
import style0 from "./view-order.vue?vue&type=style&index=0&id=f11f28c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports